export default __webpack_public_path__ + "static/media/ManualBook.6aa7a529.pdf";